$(document).ready(function() {
    displayCustomerNameInMenu();

    let timeoutCustomerName = null;

    $(window).resize(function() {

        if (timeoutCustomerName != null) {
            clearTimeout(timeoutCustomerName);
        }

        timeoutCustomerName = setTimeout(function() {
            displayCustomerNameInMenu();
        }, 200);
    });
});

/**
 * #9783 
 */
function displayCustomerNameInMenu() {
    if ($('.customer-name-menu').length <= 0) {
        return;
    }

    if ($(window).width() > 576) {
        $('.customer-name-menu').html($('.customer-name-menu').attr('data-desktop'));
    } else {
        $('.customer-name-menu').html($('.customer-name-menu').attr('data-mobile'));
    }
}